/**
 * @flow
 * @relayHash f4e6aebe305d1da866ec2c2aa3f63a04
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProxyLoginMutationVariables = {|
  user: number
|};
export type ProxyLoginMutationResponse = {|
  +proxyLogin: ?{|
    +ok: ?boolean,
    +reasons: ?any,
  |}
|};
export type ProxyLoginMutation = {|
  variables: ProxyLoginMutationVariables,
  response: ProxyLoginMutationResponse,
|};
*/


/*
mutation ProxyLoginMutation(
  $user: Int!
) {
  proxyLogin(user: $user) {
    ok
    reasons
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "user",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "proxyLogin",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "user",
        "variableName": "user",
        "type": "Int!"
      }
    ],
    "concreteType": "ProxyLoginUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reasons",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ProxyLoginMutation",
  "id": "1664872af0d6dfd358ab2648b4654ef4",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProxyLoginMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ProxyLoginMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation ProxyLoginMutation(\n  $user: Int!\n) {\n  proxyLogin(user: $user) {\n    ok\n    reasons\n  }\n}\n";
(node/*: any*/).hash = 'c82e345570e1af9f05ce61dac86f4cf9';
module.exports = node;
